export const BRAND = {
  name: 'UK Auto Tech',
  addressLine1: '',
  addressLine2: 'No. 191/A, Iddamaldeniya, Dompe',
  telephone: ' 011-2192995, 077-0314362, 077-9375368 ',
  storageKey: 'ukauto',
  localStorageKey: 'ukauto',
  sessionStorageKey: 'ukauto',
};

export const formatAddress = () => `${BRAND.addressLine1}, ${BRAND.addressLine2}`;
